// Google Analytics utility functions
declare global {
  interface Window {
    gtag: (...args: any[]) => void
    dataLayer: any[]
  }
}

// Track page views
export const trackPageView = (pagePath: string, pageTitle?: string) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', 'G-JJNHE1PYS6', {
      page_path: pagePath,
      page_title: pageTitle,
    })
  }
}

// Track custom events
export const trackEvent = (action: string, category: string, label?: string, value?: number) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    })
  }
}

// Track button clicks
export const trackButtonClick = (buttonName: string, location?: string) => {
  trackEvent('click', 'button', `${buttonName}${location ? `_${location}` : ''}`, undefined)
}

// Track app store downloads
export const trackAppStoreClick = () => {
  trackEvent('click', 'app_store', 'download_button', undefined)
}

// Track screenshot interactions
export const trackScreenshotView = (screenshotName: string) => {
  trackEvent('view', 'screenshot', screenshotName, undefined)
}

// Track screenshot clicks
export const trackScreenshotClick = (screenshotName: string) => {
  trackEvent('click', 'screenshot', screenshotName, undefined)
}

// Track language changes
export const trackLanguageChange = (language: string) => {
  trackEvent('change', 'language', language, undefined)
}
